import { baseScreeningQuestionsConfig } from '../../types/data/screening-questions/config';
export const patientScreeningQuestionsConfig = baseScreeningQuestionsConfig;
